export interface CancelQuoteBranding {
  tenant: string;
  logoSrc: string;
  logoAlt: string;
  themeClass: string;
  primaryColor: string;
  primaryColorHover: string;
  primaryColorLight: string;
}

export const CANCEL_QUOTE_BRANDING: Record<string, CancelQuoteBranding> = {
  fi: {
    tenant: 'dlp',
    logoSrc: './assets/images/fi-galaxy.svg',
    logoAlt: 'FI Galaxy',
    themeClass: 'cancel-quote-brand--fi',
    primaryColor: '#6d28d9',
    primaryColorHover: '#5b21b6',
    primaryColorLight: '#f3eefe',
  },
  diligent: {
    tenant: 'dlp',
    logoSrc: './assets/images/diligent-auto-solutions-logo-new.png',
    logoAlt: 'Diligent Auto Solutions',
    themeClass: 'cancel-quote-brand--diligent',
    primaryColor: '#00aeef',
    primaryColorHover: '#0095d9',
    primaryColorLight: '#e6f7fd',
  },
  fortegra: {
    tenant: 'dlp',
    logoSrc: './assets/images/fortegra-logo-blue-v.svg',
    logoAlt: 'Fortegra',
    themeClass: 'cancel-quote-brand--fortegra',
    primaryColor: '#002e5a',
    primaryColorHover: '#00264a',
    primaryColorLight: '#e6eef5',
  },
  afg: {
    tenant: 'dlp',
    logoSrc: './assets/images/afg logo.png',
    logoAlt: 'AFG Auto Financial Group',
    themeClass: 'cancel-quote-brand--afg',
    primaryColor: '#f27c2c',
    primaryColorHover: '#d9651c',
    primaryColorLight: '#fff0e5',
  },
};

export function getCancelQuoteBranding(
  tenant?: string | null
): CancelQuoteBranding | undefined {
  if (!tenant) {
    return undefined;
  }

  return CANCEL_QUOTE_BRANDING[tenant.toLowerCase()];
}
